//draggableLanding
export const MAIN_FOLDERS = [
    { id: 'about', label: 'About Me' },
    { id: 'work', label: 'My Work' },
    { id: 'links', label: 'Links' },
    { id: 'contact', label: 'Contact' },
    { id: 'collectibles', label: 'My Collectibles' }
];
//collectiblesPage
export const COLLECTIBLE_FOLDERS = [
    { id: 'virtualpets', label: 'Virtual Pets' },
    { id: 'cardthings', label: 'Card Things' }
];